import { render } from "./AuthPage.vue?vue&type=template&id=654ec9c4&scoped=true"
const script = {}

import "./AuthPage.vue?vue&type=style&index=0&id=654ec9c4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-654ec9c4"]])

export default __exports__